import { useSelector } from "react-redux";
import { selectDarkMode } from "store/displaySettingsSlice";

export const useDarkMode = () => {
  const isDarkMode = useSelector(selectDarkMode);
  return isDarkMode;
};
